import { BigWinLandscapeProperties } from "../landscape/BigWinLandscapeProperties";
export class BigWinPortraitProperties extends BigWinLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.lightBurstProperties.position.set(512, 909);
        this.animation.position.set(512, 680);
        this.value.position.set(512, 909);
    }
}
